export const defaultLabelCssClass = 'col-sm-5';
export const defaultContentCssClass = 'col-sm-7';
